import { render, staticRenderFns } from "./GetMessagesArchiveGroups.vue?vue&type=template&id=4dde4226&"
import script from "./GetMessagesArchiveGroups.vue?vue&type=script&lang=js&"
export * from "./GetMessagesArchiveGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports